import { UrlSegments, GetDomain } from '../app/Helpers';
import { SDBreadcrumbs, SDListItem, StructuredDataModelFactory, SDReview, SDPerson, SDReviewOrg } from '../app/Services/StrucuredData/index';
import { WaitForElementToDisplay } from '../app/Helpers/WaitForElementToDisplay';

let domain = GetDomain();
let root = UrlSegments(0);

export const InfoPages = new Promise(() => {
    let isInfoPage = (root === "Info") ? true : (root === "Legal") ? true : false;
    if (!isInfoPage) {
        return;
    }

    let section = UrlSegments(1);

    let breadcrumbItemRoot = new SDListItem(domain + "/Info/WhyChooseLifeAssist", "About Us: Why Choose Life-Assist", 1);

    function makeInfoPageBreadcrumbs(label?: string, subsection?: string) {
        let crumbName = document.title.split('|')[0];
        if (label) {
            crumbName = label;
        }
        let breadcrumbItem = new SDListItem(domain + window.location.pathname, crumbName, 2);
        let breadcrumbs = new SDBreadcrumbs([breadcrumbItemRoot, breadcrumbItem]);

        if (subsection) {
            let lastItem = new SDListItem(domain + window.location.pathname, subsection, 3);
            breadcrumbItem = new SDListItem(domain + "/" + UrlSegments(0) + "/" + UrlSegments(1) + "/", crumbName, 2)
            breadcrumbs = new SDBreadcrumbs([breadcrumbItemRoot, breadcrumbItem, lastItem]);
        }
        let sdModelFactory = new StructuredDataModelFactory();
        sdModelFactory.AddSchema(breadcrumbs);
        sdModelFactory.GenerateBreadcrumbs(breadcrumbs);
    }

    // About Us
    if (section === "WhyChooseLifeAssist") {
        console.info("Navigated to Info Pages landing");
        //makeInfoPageBreadcrumbs();
        //let breadcrumbs = new SDBreadcrumbs([breadcrumbItemRoot]);
        //new StructuredDataModelFactory().AddSchema(breadcrumbs);
    }

    if (section === "OurStory") {
        //makeInfoPageBreadcrumbs();
    }

    if (section === "MeetOurTeam") {
        console.info("Initializing MeetOurTeam VM")
        import('../app/ViewModels/Info/MeetOurTeam' /* webpackChunkName: "meetOurTeam" */).then((viewModel) => {
            console.info("MeetOurTeam VM bound");
            //makeInfoPageBreadcrumbs();
        });
    }

    if (section === "Testimonials") {
        let business = {
            "@context": "http://schema.org",
            "@type": "MedicalBusiness",
            "name": "Life-Assist",
            "slogan": "Helping Heroes Save Lives",
            "description": "Emergency Medical Supplies for the First Responder",
            "logo": GetDomain() + "/Content/img/layout/logo.jpg",
            "url": GetDomain() + "/",
            "priceRange": "$ - $$$",
            "address": {
                "@type": "PostalAddress",
                "addressLocality": "Rancho Cordova",
                "addressRegion": "CA",
                "postalCode": "95742",
                "streetAddress": "11277 Sunrise Park Dr"
            },
            "telephone": "+1-800-824-6016",
            "image": GetDomain() + "/Content/img/layout/logo.jpg"
        }
        let testimonials = document.getElementsByClassName("testimonial-row");
        let reviews = {
            "@context": "http://schema.org",
            "@type": "ItemList",
            "numberOfItems": 0,
            "itemListElement": []
        }

        Array.from(testimonials).forEach((review, index) => {
            let authorString = review.querySelector('.blockquote-footer').querySelector('span').innerText;
            let authorName = authorString.split(' of ')[0];
            let authorAgency = authorString.split(' of ').shift();
            let quote = review.querySelector('.blockquote').querySelector('span').innerText;

            let entry = new SDReview();
            entry.itemReviewed = business;
            entry.author = new SDPerson();
            entry.author.name = authorName
            //entry.datePublished = review.DateTimeStamp;
            entry.publisher = new SDReviewOrg();
            if (authorAgency) {
                entry.publisher.name = authorAgency
            }
            entry.reviewBody = quote;

            let listItem = {
                "@type": "ListItem",
                "position": index,
                "item": entry
            }

            reviews.itemListElement.push(listItem);
        })

        reviews.numberOfItems = reviews.itemListElement.length;

        new StructuredDataModelFactory().AddSchema(reviews);
    }

    // How Can We Help?
    if (section === "InsiderSignUp") {
        //let lastSection = document.title.split('|')[0];
        //makeInfoPageBreadcrumbs("Life-Assist Insider");
    }

    if (section === "ShippingReturns") {
        //makeInfoPageBreadcrumbs();
    }

    if (section === "FAQ") {
        //makeInfoPageBreadcrumbs();
    }

    // Resources
    if (section === "DisasterSupport") {
        //makeInfoPageBreadcrumbs("Disaster Support Program");
    }

    if (section === "Forms") {
        //makeInfoPageBreadcrumbs();
    }

    if (section === "DrugShortages") {
        console.info("Initializing DrugShortages VM")
        import('../app/ViewModels/Info/DrugShortages' /* webpackChunkName: "drug-shortages" */).then((viewModel) => {
            console.info("DrugShortages VM bound");
            //makeInfoPageBreadcrumbs();
        });
    }

    if (section === "ProductShortages") {
        console.info("Initializing ProductShortages VM")
        import('../app/ViewModels/Info/ProductShortages' /* webpackChunkName: "product-shortages" */).then((viewModel) => {
            console.info("ProductShortages VM bound");
            //makeInfoPageBreadcrumbs();
        });
    }

    if (section === "Recalls") {
        console.info("Initializing Recalls VM")
        import('../app/ViewModels/Info/Recalls' /* webpackChunkName: "recalls" */).then((viewModel) => {
            console.info("Recalls VM bound");
            //makeInfoPageBreadcrumbs();
        });
    }

    if (section === "ResourceLibrary") {
        console.info("Initializing ResourceLibrary VM")
        import('../app/ViewModels/Info/ResourceLibrary' /* webpackChunkName: "resource-library" */).then((viewModel) => {
            console.info("ResourceLibrary VM bound");
            //makeInfoPageBreadcrumbs();
        });
    }

    if (root === "video") {
        console.log("IS VideoPage");
        import('../app/ViewModels/Info/VideoPage' /* webpackChunkName: "video-page" */).then((viewModel) => {
            console.info("VideoPage VM bound");
        });
    }

    // Divisions
    if (section === "FedGovSvcs") {
        //makeInfoPageBreadcrumbs();
    }

    // Legal
    if (section === "Privacy-Policy") {
        //makeInfoPageBreadcrumbs();
    }

    // Testimonials
    if (section === "Testimonials") {
        console.info("Initializing Testimonials VM")
        import('../app/ViewModels/Info/Testimonials' /* webpackChunkName: "testimonials" */).then((viewModel) => {
            console.info("Testimonials VM bound");
        });
    }
});